import styled from "styled-components";

import { ThemeProp } from "styles/theme";
import tinycolor from "tinycolor2";

import { generalFonts } from "styles/font-sizes";

export const StyledPanels = styled.div`
  flex-grow: 1;
  height: 100%;

  &&&& div:not(.ant-tabs-nav-list) {
    -ms-overflow-style: none; /* Edge, Internet Explorer */
    // overflow-y: scroll;
  }

  // hides scrollbars while allowing to scroll
  div::-webkit-scrollbar:not(.ant-tabs-nav-list) {
    display: none; /* Chrome, Safari, Opera */
  }

  && div[data-testid="split-view-view"]:not(.overflow-auto),
  .allotment-container {
    overflow: visible;
  }

  .allotment-container {
    min-height: 100%;
  }

  &&&& div[data-testid="split-view-view"] {
    ::before {
      background-color: transparent;
    }
  }

  // DatasetsMenu pane styles
  //.datasets-menu-pane {
  //  z-index: 5;
  //}
`;

export const StyledClose = styled.button`
  position: absolute;
  top: 10%;
  right: 0;
  z-index: 35;
  line-height: 0;
  font-size: ${generalFonts.paragraph1}px;
  padding: 10px 5px;
  border-radius: 10px;
  transform: translate(50%, -50%);

  background: ${({ theme }: ThemeProp) => theme.emptyBackground};

  border: 1px solid
    ${({ theme }: ThemeProp) =>
      tinycolor(theme.textInLight).setAlpha(0.5).toRgbString()};
`;
